export class UserSimpleInfo {
    id: number
    name: string
    locationId: number
    location: string
    role: string
    hasBeenMarked: boolean = false
}
